import api from "./api";

export const proposalService = {
  getAll: () => api.get("/proposals").then((res) => res.data),
  getById: (id) => api.get(`/proposals/${id}`).then((res) => res.data),
  create: (data) => api.post("/proposals", data).then((res) => res.data),
  update: (id, data) =>
    api.put(`/proposals/${id}`, data).then((res) => res.data),
  delete: (id) => api.delete(`/proposals/${id}`).then((res) => res.data),
  downloadPDF: (id, includeSignature = false) => api.get(`/proposals/${id}/pdf?signature=${includeSignature}`, { responseType: "blob" }).then((res) => res.data),
};

export const invoiceService = {
  getAll: () => api.get("/invoices").then((res) => res.data),
  getById: (id) => api.get(`/invoices/${id}`).then((res) => res.data),
  create: (data) => api.post("/invoices", data).then((res) => res.data),
  update: (id, data) =>
    api.put(`/invoices/${id}`, data).then((res) => res.data),
  delete: (id) => api.delete(`/invoices/${id}`).then((res) => res.data),
  downloadPDF: (id) => api.get(`/invoices/${id}/pdf`, { responseType: "blob" }).then((res) => res.data),
};
